import "UI/Plugin/Colorpicker";
import "./Text";

/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control");

/**
 * @class
 * @extends UI.Widget.Forms.Control.Text
 */
UI.Widget.Forms.Control.Colorpicker = Class(UI.Widget.Forms.Control.Text, /**  @lends UI.Widget.Forms.Control.Colorpicker.prototype */ {
    /**
     * @protected
     * @type {$.<Element>}
     */
    $input: null,
    /**
     * @type {UI.Plugin.Colorpicker}
     * @protected
     */
    colorPicker: null,

    createElement()
    {
        this.ParentCall();
        this.$input = this.$element;
        this.$element = $("<div />").append(this.$input);

        if (this.disabled) {
            this.$element.prop("disabled", true);
            this.$input.prop("disabled", true);
        }
    },

    insertElement()
    {
        this.ParentCall();

        this.textControl = new UI.Widget.Text(this.parent, {
            element: this.$input
        });

        const value = Util.coalesce(this.getValue(), this.$control.attr('html-value'));
        const color = value != null && !isTemplate(value) ? UI.Plugin.Colorpicker.createColor(value) : undefined;

        this.colorPicker = this.textControl.use(UI.Plugin.Colorpicker, { color });
    },

    updateElement(value)
    {
        value = Util.coalesce(value, this.$control.attr('html-value'));

        this.$input.val(value);
        this.colorPicker.setColor(value != null && !isTemplate(value) ? value : undefined);
    },

    removeElement()
    {
        this.colorPicker = null;
        this.$input = null;

        this.ParentCall();
    },

    listenElement()
    {
        const format = Util.coalesce(this.$control.attr("format"), "rgbarray");

        this.colorPicker.on("select",
            /**
             * @param {{color: tinycolor}} e
             */
            (e) => {
                this.setValue(e.color ? this.colorPicker.convertColor(e.color, format) : undefined);

                Util.call(this.$control.attr("on-select"), null, [e.color]);
            });
    },

    getFormattedValue(format)
    {
        const value = this.getValue();

        if (value == null) {
            return;
        }

        if (isTemplate(value)) {
            return value;
        }

        return this.colorPicker.convertColor(this.colorPicker.createColor(value), format);
    }
});
